import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { estadoCivilKeyToLabel } from "../../../detalhes-do-projeto/filtros/estado-civil"
import { IEstadoCivil } from "../../../../../../../application/models"
// Icon
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'

export const RecorteEstadoCivilFilterPreview = (props: {
    estadoCivilFilter?: IEstadoCivil[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Estado Civil
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.estadoCivilFilter && props.estadoCivilFilter.map((estadoCivil, i) => (
                                <Chip
                                    key={i}
                                    icon={<SupervisedUserCircleIcon />}
                                    label={estadoCivilKeyToLabel(estadoCivil).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}